import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import { Box, Text, Card, Flex, Button } from 'theme-ui'
import { Stack, Main } from '@layout'
import PageTitle from '@components/PageTitle'
import Divider from '@components/Divider'
import Section from '@components/Section'
import Seo from '@widgets/Seo'

/**
 * Shadow me to add your own content
 */

const styles = {
  imageWrapper: {
    borderRadius: `default`,
    overflow: `hidden`,
    position: `relative`
  },
  button: {
    display: [`none`, `block`],
    position: `absolute`,
    bottom: 4,
    right: 4
  },
  grid: {
    flexWrap: [`wrap`, `wrap`, `nowrap`],
    ' > div + div': {
      ml: [0, 0, 5]
    }
  },
  column: {
    flex: `auto`,
    flexBasis: [`full`, `full`, `1/2`]
  }
}

export default props => {
  const data = useStaticQuery(aboutQuery)

  const { photo } = data
  const { fluid } = (photo && photo.childImageSharp) || {}

  return (
    <>
      <Seo title='About' />
      <Divider />
      <Stack>
        <Main>
          <PageTitle
            header='About Me'
            subheader='Webアプリケーションで日本を豊にし、FIRE(Finance Independence Retire Early)を目指すエンジニア。'
          />
          <Divider />
          <Box sx={styles.imageWrapper}>
            <Img fluid={fluid} />
            <Button sx={styles.button}>Contact Me</Button>
          </Box>
          <Divider />
          <Flex sx={styles.grid}>
            <Box sx={styles.column}>
              <Section title='My Story'>
                <Text variant='p'>
                  都内の医療系ベンチャーでアプリケーションエンジニアをしています。
                </Text>
                <Text variant='p'>
                  よくある、シリンコンバレーのアプリが世界を変えている世界に刺激を受けて、エンジニアという仕事をしています。
                </Text>
                <Text variant='p'>
                  上手くいかないことも事業が実態になかなか即さないもあったりしますが、日々勉強していくと技術が進化していくのを見れるのが楽しい仕事だと思います。<br />
                  このブログもその恩恵をとても受けています。
                </Text>
                <Text variant='p'>
                  本を読むのが好きで、経営者の本をよく読んでいます。好きな著者は千田琢哉さんです。
                </Text>
                <Text variant='p'>
                  経営本はよく読みますが、特に刺さった言葉は、
                </Text>
                <Text variant='p'>
                  <ul>
                    <li>お金を追うな、仕事を追え</li>
                    <li>リーダーとして成功したければ、電信柱が高いのも、郵便ポストが赤いのも、全部自分のせいだと思え</li>
                    <li>グッドはグレートの敵である</li>
                  </ul>
                </Text>
                <Text variant='p'>
                  2019年の終わり頃に、積立投資の存在を知りはじめました。
                </Text>

                <Text variant='p'>
                  ベースは米国高配当ETFに投資しています。リターンはまだ小さいですが、継続は力なり。
                </Text>
                <Text variant='p'>
                  そんな感じです、どもども!
                </Text>
              </Section>
            </Box>
            <Box sx={styles.column}>
              <Section title='skills'>
                <Card variant='paper'>
                  仕事で使うのは、Ruby on Rails, Angular などが多いです。<br />
                  普段はお金周りの機能を触ることが多く、stripe なども触っています。<br />
                  また、数年稼働しているアプリのフロントリニューアルのリードエンジニアを担当してきました。
                </Card>
              </Section>
              <Divider />
              <Section title='趣味'>
                <Card variant='paper'>
                  積立投資をすることにハマっています。個人的に押しているETFはVYMを購入していて、サイドFIREをするために日々積み立てています（何年後達成できるんだ..)<br />
                  あとはよく本を読みます。機械学習にもハマっている時期がありpythonなどもかじっていました。
                </Card>
              </Section>
              <Divider />
              <Section title='このサイトについて'>
                <Card variant='paper'>
                  自分のブログは作りたいけど、wordpress でいい感じに管理できないし php 触ったことないけど改めてやるつもりもないんだけどいいのないかな..<br />
                  そんな時に出会った GatsbyJS でこのサイトは作られています。nextJS もいいかなと思いつつ個人でやるには GatsbyJS の方が早く作れそうだったので GatsbyJS を採用しました。<br />
                  流行りの JAMstack に...!
                </Card>
              </Section>
            </Box>
          </Flex>
        </Main>
      </Stack>
    </>
  )
}

const aboutQuery = graphql`
  query AboutQuery {
    photo: file(absolutePath: { regex: "/logo-dark.(jpeg|jpg|gif|png)/" }) {
      childImageSharp {
        fluid(maxWidth: 1140, maxHeight: 500, cropFocus: NORTH) {
          ...GatsbyImageSharpFluid_noBase64
          width: presentationWidth
          height: presentationWidth
        }
      }
    }
  }
`
